import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyMobileCTA from "./components/StickyMobileCTA";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import SituationPage from "./pages/SituationPage";
import GetOffer from "./pages/GetOffer";
import RequestOffer from "./pages/RequestOffer";
import ThankYou from "./pages/ThankYou";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLeadDetail from "./pages/AdminLeadDetail";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main className="pb-24 lg:pb-0">{children}</main>
      <Footer />
      <StickyMobileCTA />
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/leads/:id" element={<AdminLeadDetail />} />
      </Routes>
    );
  }
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/request-offer" element={<RequestOffer />} />
        <Route path="/get-offer" element={<GetOffer />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/sell-probate-house" element={<SituationPage />} />
        <Route path="/stop-foreclosure" element={<SituationPage />} />
        <Route path="/sell-inherited-house" element={<SituationPage />} />
        <Route path="/sell-house-tax-lien" element={<SituationPage />} />
        <Route path="/sell-house-as-is" element={<SituationPage />} />
        {/* Route-param fallback so we can add more via config only */}
        <Route path="/:slug" element={<SituationPage />} />
      </Routes>
    </PublicLayout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ChatWidget />
        <Shell />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}
